import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";

import Heading from "../components/common/Heading";
import CommonHeading from "../components/common/CommonHeading";
import { contact } from "../components/data/Data";

export default function Contact() {
  const form = useRef();

  // Modal State
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_umekqe5",
        "template_9x9m7i1",
        form.current,
        "42kkNaVyUx5TskUtR"
      )
      .then(
        (result) => {
          setIsSuccess(true);
          setModalMessage("Message sent successfully!");
          setShowModal(true);
          form.current.reset();
        },
        (error) => {
          setIsSuccess(false);
          setModalMessage("Failed to send message. Please try again!");
          setShowModal(true);
        }
      );
  };

  return (
    <>
      <Heading heading="Contact" title="Home" subtitle="Contact" />

      <div className="container-xxl py-5">
        <div className="container">
          <CommonHeading
            heading="Contact Us"
            subtitle="Contact"
            title="For Any Query"
          />

          <div className="row g-4">
            {/* Contact Info */}
            <div className="col-12">
              <div className="row gy-4">
                {contact.map((item, index) => (
                  <div className="col-md-3" key={index}>
                    <h6 className="section-title text-start text-primary text-uppercase">
                      {item.title}
                    </h6>
                    <p>
                      {item.icon}
                      {item.email}
                    </p>
                  </div>
                ))}
              </div>
            </div>

            {/* Map */}
            <div className="col-md-6">
              <iframe
                title="Map"
                className="w-100 rounded"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7814.620348345297!2d76.13666979357912!3d11.672416100000008!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba60b0032b257bf%3A0xb1f27b23c7f9dca9!2sDaps%20Home%20Family%20Appartment%20for%20rental!5e0!3m2!1sen!2sin!4v1785999144893!5m2!1sen!2sin"
                style={{ minHeight: "350px", border: 0 }}
                allowFullScreen
              ></iframe>
            </div>

            {/* Form */}
            <div className="col-md-6">
              <form ref={form} onSubmit={sendEmail}>
                <div className="row g-3">
                  <div className="col-md-6">
                    <input
                      type="text"
                      name="user_name"
                      className="form-control"
                      placeholder="Your Name"
                      required
                    />
                  </div>

                  <div className="col-md-6">
                    <input
                      type="email"
                      name="user_email"
                      className="form-control"
                      placeholder="Your Email"
                      required
                    />
                  </div>

                  <div className="col-12">
                    <input
                      type="text"
                      name="subject"
                      className="form-control"
                      placeholder="Subject"
                      required
                    />
                  </div>

                  <div className="col-12">
                    <textarea
                      name="message"
                      className="form-control"
                      placeholder="Message"
                      style={{ height: "150px" }}
                      required
                    ></textarea>
                  </div>

                  <div className="col-12">
                    <button className="btn btn-primary w-100 py-3">
                      Send Message
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* MODAL */}
      {showModal && (
        <div className="modal fade show d-block" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">

              <div className={`modal-header ${isSuccess ? "bg-success" : "bg-danger"} text-white`}>
               <h5
  className="modal-title"
  style={{ color: "#fff" }}
>
  {isSuccess ? "Success" : "Error"}
</h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>

              <div className="modal-body">
                <p>{modalMessage}</p>
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Close
                </button>
              </div>

            </div>
          </div>
        </div>
      )}

      {/* Modal Backdrop */}
      {showModal && <div className="modal-backdrop fade show"></div>}
    </>
  );
}